import styled from "styled-components";

export const FormItem = styled.div`
  &::first-letter {
    text-transform: uppercase;
  }
`;

export const Label = styled.label`
  font-weight: 600;
`;
